"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getSources = _interopRequireDefault(require("../../../actions/source/getSources"));
var _actionUtils = require("../../../utils/actionUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function sourceDeleted(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _getSources["default"])());
  }
}
var _default = exports["default"] = sourceDeleted;